/*ěščřžýáíéúů*/
(function ($) {
	const $nav       = $('.products-nav');
	const $navItems  = $nav.find('.products-nav__item');
	const $siteHeader = $('header.site-header');
	const scrollOffset = 230;

	// ── Sticky nav ────────────────────────────────────────────────────────────

	const navNaturalTop = $nav.offset().top;

	function updateStickyNav() {
		const headerHeight = $siteHeader.outerHeight();
		const shouldFix = $(document).scrollTop() >= navNaturalTop - headerHeight;
		$nav.toggleClass('products-nav--fixed', shouldFix);
		if (shouldFix) {
			$nav.css('top', headerHeight + 'px');
		} else {
			$nav.css('top', '');
		}
	}

	$(document).on('scroll', updateStickyNav);
	$(window).on('resize', updateStickyNav);

	// ── Active item & smooth scroll ───────────────────────────────────────────

	function activateItem($item) {
		$navItems.removeClass('products-nav__item--active');
		$item.addClass('products-nav__item--active');
	}

	function scrollToSection(slug) {
		const $target = $('#' + slug);
		if ($target.length) {
			$('html, body').animate({ scrollTop: $target.offset().top - scrollOffset }, 500);
		}
	}

	$navItems.on('click', function () {
		activateItem($(this));
		scrollToSection($(this).data('target'));
	});

	if (window.location.hash) {
		const hash    = window.location.hash.substring(1);
		const $target = $navItems.filter('[data-target="' + hash + '"]');
		if ($target.length) {
			activateItem($target);
			scrollToSection(hash);
		}
	} else {
		activateItem($navItems.first());
	}

	// ── Mobile label override ─────────────────────────────────────────────────

	if ($(window).innerWidth() <= 800) {
		$navItems.filter('[data-target="vzduch-technologicke-produkty"]').text('Ostatní');
	}
})(jQuery);
